import { INIT_TOOLBAR_REQUEST, INIT_TOOLBAR_SUCCESS, INIT_TOOLBAR_FAILURE } from './constants';
import { CALL_API } from '../../middlewares/api';

export function initToolbar(browser) {
    return {
        [CALL_API]: {
            endpoint: `/trace/toolbar/download?browser=${browser}`,
            types: [INIT_TOOLBAR_REQUEST, INIT_TOOLBAR_SUCCESS, INIT_TOOLBAR_FAILURE],
            body: {}
        }
    };
}



// WEBPACK FOOTER //
// ./src/services/toolbar/actions.js